import { useEffect, useState } from "react";
import { TooltipStyled, TooltipText } from "./style-component";
import { motion } from "motion/react"
import { Tooltip } from "antd";
import { useTheme } from "@/contexts/theme-context/useThemeContext";
import { CustomTooltipProps } from "./tooltip-types";
import ProgressDots from "../progress-dots.tsx/progress-dots";

const CustomTooltip: React.FC<CustomTooltipProps> = ({ items, duration = 3000, children }) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const { theme } = useTheme();

  const handleOpenChange = (open: boolean) => {
    if (open) {
      setCurrentIndex(0);
    }
  }

  useEffect(() => {
    if (!items || items.length === 0) return;

    const interval = setInterval(() => {
      if (currentIndex + 1 >= items.length) {
        clearInterval(interval);
        setCurrentIndex(0);

      } else {
        setCurrentIndex(prev => prev + 1);
      }
    }, duration)

    return () => {
      clearInterval(interval);
    }
  }, [items, currentIndex, duration]);

  return (
    <Tooltip
      overlayStyle={{ maxWidth: "none" }}
      overlayInnerStyle={{ padding: "0", borderRadius: "12px", backgroundColor: "#0000", boxShadow: "none" }}
      onOpenChange={handleOpenChange}
      title={
        <TooltipStyled>
          {items[currentIndex].illustration && items[currentIndex].illustration}
          {items.length > 1 &&

            <motion.div
              style={{ height: "2px", background: theme.colors.theme.brandColor3 }}
              key={`progress-${currentIndex}`}
              initial={{
                width: "0%",
              }}
              animate={{
                width: "100%",
              }}
              transition={{
                duration: duration / 1000,
                ease: "linear",
              }}
              data-testid="progress-bar"
            >
            </motion.div>
          }
          <TooltipText>
            {items[currentIndex].message}
            {items.length > 1 && <ProgressDots items={items} currentItemIndex={currentIndex}/>}
          </TooltipText>
        </TooltipStyled>
      }
    >
      {children}
    </Tooltip>
  )
}

export default CustomTooltip;